import React from "react";
import { useStepData } from "../../../hooks/useStepData";
import { useFunnelNavigation } from "../../../hooks/useFunnelNavigation";
import { StepHeader } from "../../common/StepHeader";

export function RatingScale({ config }) {
  const { data, updateStepData } = useStepData(config.field);
  const { nextStep } = useFunnelNavigation();

  const handleSelect = (rating) => {
    updateStepData(rating);
    setTimeout(() => {
      nextStep();
    }, 220);
  };

  return (
    <div className="space-y-2 px-4">
      <StepHeader
        title={config.title}
        subtitle={config.subtitle}
        order={config.headerOrder}
      />

      <div className="space-y-6">
        <div className="grid grid-cols-5 gap-2">
          {[1, 2, 3, 4, 5].map((rating) => (
            <button
              key={rating}
              onClick={() => handleSelect(rating)}
              className={`
                aspect-square rounded-xl transition-all duration-200
                flex items-center justify-center text-xl font-semibold
                ${
                  data === rating
                    ? "bg-green-50 border-2 border-green-500 text-green-700"
                    : "bg-white border-2 border-gray-200 text-gray-700"
                }
              `}
            >
              {rating}
            </button>
          ))}
        </div>

        <div className="flex justify-between text-sm text-gray-500 px-2">
          <span>{config.minLabel}</span>
          <span>{config.maxLabel}</span>
        </div>
      </div>
    </div>
  );
}
